import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import SEOHead from "@/components/SEOHead";
import { articles } from "@/data/articles";

const baseUrl = "https://playfieldvr.nl";

const Kennisbank = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Kennisbank VR teambuilding",
    url: `${baseUrl}/kennisbank`,
    description:
      "Artikelen over VR teambuilding, bedrijfsuitjes, prijzen en praktische voorbereiding.",
    hasPart: articles.map((article) => ({
      "@type": "Article",
      headline: article.h1,
      description: article.description,
      datePublished: article.datePublished,
      url: `${baseUrl}/kennisbank/${article.slug}`,
      author: { "@type": "Organization", name: "PlayfieldVR" },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Kennisbank VR Teambuilding | Tips en Prijzen – PlayfieldVR"
        description="Artikelen over VR teambuilding: wat een bedrijfsuitje kost, hoeveel ruimte je nodig hebt en welke activiteit bij jouw team past."
        canonicalPath="/kennisbank"
        structuredData={structuredData}
      />
      <Navigation />

      <main>
        <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
          <div className="max-w-3xl mx-auto">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors mb-8"
            >
              <ArrowLeft className="w-4 h-4" />
              Terug naar Home
            </Link>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">
              Kennisbank: VR teambuilding en bedrijfsuitjes
            </h1>

            <p className="text-lg text-muted-foreground mb-12">
              Praktische artikelen voor iedereen die een VR-activiteit voor een team
              organiseert: van prijsopbouw tot de ruimte die je nodig hebt op kantoor.
            </p>

            <ul className="grid gap-6">
              {articles.map((article) => (
                <li key={article.slug}>
                  <article className="rounded-lg border border-border bg-card/50 p-6 hover:border-primary/60 transition-colors">
                    <h2 className="text-xl sm:text-2xl font-semibold text-foreground mb-2">
                      <Link to={`/kennisbank/${article.slug}`} className="hover:text-primary transition-colors">
                        {article.h1}
                      </Link>
                    </h2>
                    <p className="text-sm text-muted-foreground mb-3">
                      {article.readingTime} leestijd
                    </p>
                    <p className="text-muted-foreground mb-4">{article.excerpt}</p>
                    <Link
                      to={`/kennisbank/${article.slug}`}
                      className="inline-flex items-center gap-2 text-primary hover:underline"
                    >
                      Lees het artikel
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </article>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default Kennisbank;
